import type { CSSProperties } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Ic } from '../../components/Ic';
import './login.css';

const waves = [
  'M0 120 C 240 80, 480 160, 720 110 S 1200 60, 1440 130 L 1440 900 L 0 900 Z',
  'M0 230 C 240 190, 480 270, 720 220 S 1200 170, 1440 240 L 1440 900 L 0 900 Z',
  'M0 340 C 240 300, 480 380, 720 330 S 1200 280, 1440 350 L 1440 900 L 0 900 Z',
  'M0 450 C 240 410, 480 490, 720 440 S 1200 390, 1440 460 L 1440 900 L 0 900 Z',
  'M0 560 C 240 520, 480 600, 720 550 S 1200 500, 1440 570 L 1440 900 L 0 900 Z',
  'M0 670 C 240 630, 480 710, 720 660 S 1200 610, 1440 680 L 1440 900 L 0 900 Z',
  'M0 780 C 240 740, 480 820, 720 770 S 1200 720, 1440 790 L 1440 900 L 0 900 Z',
];

/** Stagger index for the one-time entrance (login.css .login-view__in). */
const step = (i: number) => ({ '--i': i }) as CSSProperties;

export function LoginView() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  return (
    <main className="login-view" aria-labelledby="login-title">
      <svg className="login-view__waves" viewBox="0 0 1440 900" preserveAspectRatio="none" aria-hidden="true">
        {waves.map((d, index) => <path key={d} d={d} fill={`rgba(${20 + index * 4}, ${24 + index * 4}, ${70 + index * 8}, .18)`} />)}
      </svg>
      <section className="login-view__card">
        <div className="login-view__in" style={step(0)}>
          <div className="login-view__orb" aria-hidden="true"><span /></div>
          <h1 id="login-title">Flux <span>Raffles</span></h1>
          <p className="login-view__kicker">Raffle monitoring · Live delivery</p>
        </div>
        <div className="login-view__in" style={step(1)}>
          {error && <p className="login-view__error" role="alert"><Ic.alert aria-hidden="true" />{error}</p>}
          <a className="login-view__discord" href="/auth/discord/login">
            <Ic.discord aria-hidden="true" />
            Sign in with Discord
          </a>
          <p className="login-view__members">Exclusive to Flux Discord members</p>
        </div>
        <p className="login-view__status login-view__in" style={step(2)}><span />Secure Discord OAuth · access is managed by Flux</p>
      </section>
    </main>
  );
}
